import type { AnnieChatItem } from "@/hooks/useAnnie";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import type { AssistantAvatarConfig, AssistantAvatarMood } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { type ChatTurnLayout, layoutChatTurns } from "@/ui/Chat/chatTurns";

export const ANNIE_TURN_AVATAR_SIZE = ASSISTANT_AVATAR.SIZE.TURN;

/** The user's Annie design and what she is doing right now, for the conversation column. */
export interface AnnieConversationAvatar {
	config: AssistantAvatarConfig;
	mood: AssistantAvatarMood;
}

export const layoutAnnieTurns = (items: AnnieChatItem[]): ChatTurnLayout => layoutChatTurns(items, (item) => item.kind !== "user");
